export const ACCOUNT_TYPES = {
  DEMO: "DEMO",
  LIVE: "LIVE",
  IB: "IB",
};
